<template>
  <vvs-control-wrapper>
    <button type="submit" class="next-button">
      <slot>{{ title }}</slot>
    </button>
    <p class="ps" v-if="description">{{ description }}</p>
  </vvs-control-wrapper>
</template>

<script>
export default {
  name: 'VvsSubmitButton',
  props: {
    title: {
      type: String,
    },
    description: {
      type: String,
    },
  },
};
</script>
